module.exports = __webpack_public_path__ + "img/recessionproofcapital-square.0790cc44.png";